// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2lQju","label":"CategoryService_label__mz2bo","location":"CategoryService_location__2Oxgw"};